(function () {
  const ESC_KEY = 27;
  const $drawerTogglers = $("[data-drawer-toggle]");
  const $drawerContents = $("[data-drawer-id]");
  // Main entry point for this js. Handle open and close action of drawer.

  $drawerTogglers.attr({
    role: "button",
    "aria-expanded": "false",
  });

  $drawerContents.attr({
    "aria-hidden": "true",
  });

  // Listen to [drawer-toggle] element's action
  // Trigger 'toggle' function when element on click

  $drawerTogglers.on("click", function () {
    toggleDrawer($(this));
  });

  // Listen to esc key to close the drawer
  $(document).on("keydown.toggle-drawer", function (event) {
    let key = event.keyCode || event.which;
    if (key === ESC_KEY) {
      toggleDrawer(event);
    }
  });
})();

const $drawerContainer = $("[data-drawer-container]");
const toggleDrawer = (e) => {
  const $toggler = e;
  const isOpen = $drawerContainer.hasClass("drawer-open");

  if (!isOpen) openDrawer($toggler, $drawerContainer);
  else closeDrawer($toggler, $drawerContainer);
};

export function openDrawer($toggler, container) {
  const $drawer = getTogglerDrawerElement($toggler);
  const drawerId = $toggler.attr("data-drawer-toggle");

  setTimeout(function () {
    container.addClass("drawer-open");

    if ($toggler.has("[data-drawer-toggle]")) {
      container.addClass(`drawer-open--${drawerId}`);
      $(`[data-drawer-toggle="${drawerId}"]`).attr("aria-expanded", "true");
      $drawer.attr({
        "aria-hidden": "false",
      });
    }
  }, 25);
}

export function closeDrawer(toggler, container) {
  const currentDrawer = getCurrentDrawer();
  const drawer = $(`[data-drawer-id="${currentDrawer}"]`);

  container.removeClass(getDrawerClass);

  $(`[data-drawer-toggle="${currentDrawer}"]`).attr("aria-expanded", "false");

  drawer.attr({
    "aria-hidden": "true",
  });
}

const getDrawerClass = (index, className) => {
  let result = "";
  const array = className.split(" ");

  for (let i = 0; i < array.length; i++) {
    if (array[i].match("drawer-open")) result += array[i] + " ";
  }

  return result;
};

const getCurrentDrawer = () => {
  let array = $drawerContainer.attr("class").split(" ");

  for (let i = 0; i < array.length; i++) {
    if (array[i].match("drawer-open--")) {
      return array[i].replace("drawer-open--", "");
    }
  }

  return null;
};

const getTogglerDrawerElement = (toggler) => {
  return $(`[data-drawer-id="${toggler.attr("data-drawer-toggle")}"]`);
};
